module.exports = __webpack_public_path__ + "media/images/j_peeterse-a58d6721d70066d3ffd1069512c254c7.png";